export enum PrintModalType {
    Product = 'product',
    PurchaseOrder = 'purchase-order'
}
